export default "__VITE_ASSET__C1E9TRLk__"